import Vue from 'vue'
import Router from 'vue-router'
import Students from './views/Students.vue'
import Admin from './views/Admin.vue'
import Login from './views/Login.vue'
import Signup from './views/Signup.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import Staff from './views/Staff.vue'
import PTO from './views/PTO.vue'
import Information from './views/Information.vue'
import AddStudent from './views/AddStudent.vue'
import firebase from 'firebase'
import store from './store';

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/students'
    },
    {
      path: '/students',
      name: 'students',
      component: Students,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/staff',
      name: 'staff',
      component: Staff,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pto',
      name: 'pto',
      component: PTO,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/new-student',
      name: 'new-student',
      component: AddStudent
    },
    {
      path: '/new-student/:pin',
      name: 'new-student-pin',
      component: AddStudent
    },     
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: Information
    }
  ]
})

router.beforeEach((to,from, next) => {
  
  let currentUser = firebase.auth().currentUser;
  console.log('Router beforeEach: firebase user: ', currentUser);
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  if(requiresAuth && !currentUser) {
    //user trying to access secured page and not logged in 
    next('login')
  }
  else if(requiresAuth && currentUser) {
    //user is accessing a secured page and is already logged in, check if admin page as well
    
    
    if(requiresAdmin && !store.state.isAdmin) {
      //assume logged in (only way these variables are set anyway)
      //if not an admin, redirect to home
      next('/')
    }
    else {
      if(!store.state.profileLoaded) {
        //load the user profile into store before navigating
        store.dispatch('updateUser').then(() => {
          next();
        });
      } else {
        store.commit('updateStuff',{});
        next();
      }
      //
      //next();
    }
  }
  else {
    next();
  }
})

export default router;